<div class="relative w-full h-full" [class]="hStyleClass">
  <img
    [ngSrc]="
      logoFileName
        ? getUploadPath('logo', logoFileName)
        : 'assets/images/logo/logo-keck.png'
    "
    alt="logo"
    fill
    priority
    style="object-fit: contain" />
</div>
